import React from 'react';
import _ from 'lodash';
import { Card, Loader, Dimmer } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';

import TaskContainer from '../TaskContainer';
import ProgressBar from '../ProgressBar';
import FNRouter from './FNRouter';
import ConfirmForceRecreation from './ConfirmForceRecreation';

const CustomTask = ({
  taskType,
  task,
  claim,
  loading,
  error,
  taskTitle,
  taskValues,
  navigateToSummary,
  navigateToSummaryNoQuery,
  handleBack,
  handleNext,
  disabledNext,
  handleSubmit,
  confirmForceModalVisible,
  ...restProps
}) => {
  const taskId = _.get(task, 'id');
  if (!taskId || !claim || error) return null; // redirect to tasks?

  const {
    currentStage,
    currentSection,
    stages,
    sections,
    sectionsData
  } = taskValues;

  const fullOptionsData =
    taskType === 'LFN'
      ? claim.legalFormalNoticeTemplatePresection
      : claim.courtApplicationTemplatePresection;

  const isLastStage = currentStage === stages[stages.length - 1];

  return (
    <TaskContainer
      title={taskTitle}
      {...restProps}
      {...task}
      claimId={task.claimId}
    >
      <ProgressBar
        taskType={taskType}
        stages={stages}
        currentStage={currentStage}
        sections={sections}
        currentSection={currentSection}
        sectionsData={sectionsData}
      />
      <Card.Description>
        {confirmForceModalVisible && (
          <ConfirmForceRecreation
            handleAccept={navigateToSummary}
            handleReject={navigateToSummaryNoQuery}
            taskType={taskType}
          />
        )}
        {loading ? (
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        ) : (
          <FNRouter
            taskType={taskType}
            claimId={task.claimId}
            taskValues={taskValues}
            fullOptionsData={fullOptionsData}
            navButtonsProps={{
              showSubmit: isLastStage,
              onBack: handleBack,
              onNext: handleNext,
              disabledNext: disabledNext,
              onSubmit: handleSubmit
            }}
            {...restProps}
            {...taskValues}
          />
        )}
      </Card.Description>
    </TaskContainer>
  );
};

export default withRouter(CustomTask);



// WEBPACK FOOTER //
// ./src/component/TaskCreator/CustomTask.js